import {
  Box,
  Container,
  Divider,
  Link,
  Stack,
  Typography
} from '@mui/material';
import { LangSwitch, theme } from '@pagopa/mui-italia';
import './footer.css';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';
import { languages } from '../../translations/language';
import Cielogo from '../../icons/Cielogo';

const Footer = () => {
  const { t } = useTranslation();

  const { language, changeLanguage } = useLanguage();

  const footerLinks = [
    { label: t('footer.privacy'), href: '#' },
    { label: t('footer.tos'), href: '#' },
    { label: t('footer.accessibility'), href: '#' }
  ];

  return (
    <>
      <Box component={'footer'} bgcolor={'customBlue.main'}>
        <Container>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            justifyContent={{ xs: 'center', md: 'space-between' }}
            alignItems="center"
            gap={4}
            p={3}
          >
            <Cielogo
              title={'Logo ' + t('commons.cieTitle')}
              height="32"
              width="64"
            />
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              justifyContent={{ xs: 'center', md: 'space-between' }}
              alignItems="center"
              textAlign="center"
              gap={2}
              p={0}
              m={0}
              component={'ul'}
            >
              {footerLinks.map((link, index) => (
                <Stack component={'li'} sx={{ listStyle: 'none' }} key={index}>
                  <Link
                    fontSize={14}
                    fontWeight={'600'}
                    underline="none"
                    href={link.href}
                    color={'primary.contrastText'}
                    variant="body2"
                  >
                    {link.label}
                  </Link>
                </Stack>
              ))}
              <Stack
                component={'li'}
                sx={{ listStyle: 'none' }}
                id="lang-switch"
              >
                <LangSwitch
                  currentLangCode={language}
                  languages={languages}
                  onLanguageChanged={changeLanguage}
                />
              </Stack>
            </Stack>
          </Stack>
          <Divider sx={{ borderBottomColor: 'customBlue.dark' }} />
          <Stack textAlign="center" alignItems="center" p={3}>
            <Typography
              fontWeight={'600'}
              color={'primary.contrastText'}
              fontSize={14}
              component={'span'}
              maxWidth={{ xs: theme.spacing(59), md: '100%' }}
            >
              {t('commons.ministryOfInterior')}
              <Typography
                color={'primary.contrastText'}
                variant="body2"
                component={'span'}
                fontSize={14}
              >
                {/*
                &nbsp; is a non braking space
                &#xB7; is a "·" char html encoded
                */}
                &nbsp;&#xB7;&nbsp;{t('commons.ministryAddress')}
              </Typography>
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Footer;
